
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'feedback-public-submission-ui',
  currentProjectVersion: 'static-1.30711',
  depVersions: {
  "feedback-public-submission-ui": "static-1.30711",
  "emoji-mart": "static-3.4",
  "feedback-schema": "static-1.55218",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8274",
  "hubspot-dlb": "static-2.1882",
  "HubStyleTokens": "static-2.11730",
  "I18n": "static-7.1661",
  "quartz": "static-1.7365",
  "quartz-config": "static-1.1143",
  "quartz-core": "static-1.6584",
  "react-dlb": "static-1.84",
  "react-dnd": "static-4.51",
  "react-dnd-html5-backend": "static-2.10",
  "redux-mock-store": "static-1.8",
  "redux-thunk": "static-2.77",
  "reselect": "static-3.9",
  "sinon": "static-1.9",
  "tinymce": "static-6.5",
  "cssUtils": "static-1.870",
  "enviro": "static-4.455",
  "feedback-shared-ui": "static-1.55205",
  "feedback-utils": "static-1.55209",
  "forms-embed-utils-lib": "static-1.4712",
  "forms-utils-lib": "static-1.13018",
  "foundations-assets": "static-1.5123",
  "foundations-components": "static-1.8383",
  "foundations-theming": "static-1.4702",
  "hub-http": "static-1.6458",
  "hubspot-url-utils": "static-1.4297",
  "HubStyle": "static-2.12037",
  "icons": "static-2.674",
  "immutable": "static-2.83",
  "quick-fetch": "static-1.4093",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-dom": "static-7.85",
  "react-input-autosize": "static-2.17",
  "react-redux": "static-7.75",
  "react-rhumb": "static-1-unify-reporter-duration-calculations.6",
  "react-select-plus": "static-1.109",
  "react-utils": "static-2.5516",
  "react-virtualized": "static-2.104",
  "redux": "static-4.76",
  "StyleGuideUI": "static-3.495",
  "tinymce-plugins": "static-1.58112",
  "transmute": "static-2.85",
  "ui-images": "static-2.1229",
  "UIComponents": "static-3.8676",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "metrics-js": "static-1.9867",
  "styled-components": "static-2.95",
  "bend-plugin-trellis-migration": "static-1.3575",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3642",
  "quartz-webpack": "static-1.3589",
  "foundations-theming-specialty": "static-1.2418",
  "property-description-translator": "static-1.4085",
  "HeadJS": "static-2.789",
  "framer-motion": "static-1.76",
  "hs-test-utils-bend-plugin": "static-1.3385",
  "msw": "static-1.39",
  "testing-library": "static-1.156",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.87",
  "jasmine": "static-4.4564",
  "jasmine-runner": "static-1.6696",
  "dispatcher": "static-1.141",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.867",
  "hubspotter-http": "static-1.4824",
  "mobile-manifest-mixins": "static-1.565",
  "module-federation": "static-1.30",
  "quartz-auth": "static-1.1040",
  "quartz-head": "static-1.1030",
  "quartz-i18n": "static-1.1040",
  "quartz-routing": "static-1.795",
  "quartz-test": "static-1.1040",
  "quartz-tracking": "static-1.744",
  "trellis-components": "static-1.2487",
  "ui-fonts": "static-1.992",
  "usage-tracker-container": "static-1.7592",
  "usage-tracker-core": "static-1.7452",
  "hs-lodash": "static-4.45",
  "sassPrefix": "static-1.161",
  "conversations-skeleton-state": "static-1.7495",
  "reference-resolvers": "static-1.8429",
  "sanitize-text": "static-1.8396",
  "PatternValidationJS": "static-1.3143",
  "ReduxMessenger": "static-2.10613",
  "sanitize": "static-1.4722",
  "outpost": "static-1.4408",
  "rpc-client-utils": "static-1.4909",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4652",
  "floating-ui": "static-1.61",
  "hs-story-utils": "static-1.9674",
  "react-aria": "static-1.70",
  "react-create-root-preference": "static-1.60",
  "tanstack-table": "static-1.59",
  "trellis-assets": "static-1.2468",
  "bend-plugin-foundations-theming": "static-1.3185",
  "foundations-theming-base": "static-1.3687",
  "stylex": "static-1.38",
  "hs-locale-management": "static-1.255",
  "csstype": "static-1.50",
  "web-vitals": "static-1.11",
  "ai-components-ui-library": "static-1.9579",
  "atom": "static-1.5331",
  "codemirror": "static-5.99",
  "content-assistance-lib": "static-1.8130",
  "ContentUtils": "static-1.69053",
  "data-token-picker": "static-1.16813",
  "file-manager-components": "static-1.24360",
  "FileManagerCore": "static-1.39859",
  "FileManagerLib": "static-1.40000",
  "frontend-preferences-client": "static-1.8174",
  "hub-http-contrib": "static-1.3285",
  "interframe": "static-3.5003",
  "layout-dnd-components": "static-1.12890",
  "layout-dnd-utils": "static-1.11865",
  "property-translator": "static-1.5641",
  "react-codemirror": "static-1.10886",
  "react-colorpicker": "static-2.10454",
  "reference-resolvers-lite": "static-1.8346",
  "rich-text-lib": "static-1.20235",
  "tinymce-data": "static-1.41083",
  "tinymce-themes": "static-1.56968",
  "ui-addon-emoji-picker": "static-1.10132",
  "ui-addon-sales-email": "static-1.5461",
  "ui-brand-identity-lib": "static-1.16217",
  "bender-build-tools": "static-1.3358",
  "hub-http-shared-msw-handlers": "static-1.10525",
  "hubspotter-http-shared-msw-handlers": "static-1.10523",
  "usage-tracker-session-replay": "static-1.5288",
  "base-ui": "static-1.19",
  "react-day-picker": "static-1.7",
  "trellis-theming": "static-1.1207",
  "tanstack-virtual": "static-1.36",
  "autolinker": "static-3.11",
  "bend-plugin-chirp-manifest": "static-1.319",
  "chirp-fetch": "static-1.2137",
  "chatspot-core": "static-1.22631",
  "copilot-toolkit": "static-1.11740",
  "customer-data-objects-ui-components": "static-1.13277",
  "data-fetching-client": "static-1.9903",
  "diff-match-patch": "static-1.7",
  "superstore": "static-1.5005",
  "ui-addon-video-player": "static-1.8952",
  "ui-coaching-tips": "static-1.29210",
  "usage-tracker": "static-1.7602",
  "cms-field-types": "static-1.5061",
  "content-icons-ui": "static-1.2310",
  "integrations-lib": "static-1.16923",
  "customer-data-objects": "static-1.7934",
  "apollo-dlb": "static-3.86",
  "breeze-engine-lib": "static-1.1567",
  "apollo-link-hub-http": "static-2.4903",
  "apollo-stack-hubspot": "static-3.90",
  "graphql": "static-1.86",
  "immer": "static-1.94",
  "immerable": "static-1.4398",
  "ui-addon-iframeable": "static-1.9323",
  "video-components-external": "static-1.12053",
  "video-data-lib": "static-1.35711",
  "breeze-artifacts-sdk": "static-1.185",
  "audio-components": "static-1.6272",
  "cropperjs": "static-1.10",
  "feedback-loader": "static-1.29734",
  "FileManagerImages": "static-1.37511",
  "foundations-components-legacy": "static-1.1408",
  "html-to-image": "static-1.58",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.75",
  "salesImages": "static-1.530",
  "ui-universal-auth": "static-1.9286",
  "urlinator": "static-1.4780",
  "video-components": "static-1.14055",
  "video-embed": "static-1.36545",
  "ts-schema": "static-1.4254",
  "ContentData": "static-1.69128",
  "layout-data-lib": "static-1.10190",
  "react-dnd-compat": "static-1.4862",
  "browser-eslint": "static-2.57",
  "batch-promise": "static-1.1791",
  "external-options-client-types": "static-1.4301",
  "fast-json-stable-stringify": "static-1.4",
  "framework-data-schema-resolvers": "static-1.7141",
  "hs-promise-utils": "static-1.5842",
  "inbound-db-properties-service-client": "static-1.4018",
  "NamespacedHubStyle": "static-2.9224",
  "growth-onboarding-confetti": "static-1.3308",
  "SharedI18nStrings": "static-1.182",
  "ui-addon-i18n": "static-1.11393",
  "amplitude-session-replay-browser": "static-1.60",
  "markdown-it": "static-1.6",
  "magpie-lib": "static-1.5718",
  "magpie-types": "static-1.5178",
  "simple-logging-lib": "static-1.3296",
  "avatar-components": "static-1.2743",
  "customer-data-ui-utilities": "static-1.10072",
  "growth-onboarding-feedback-components": "static-1.6829",
  "flux-actions": "static-1.360",
  "hubspot-apollo-client": "static-1.5124",
  "integrations-error-boundary-lib": "static-1.14338",
  "integrations-tracking-lib": "static-1.5855",
  "laboratory-lib": "static-3.7399",
  "native-integrations-shared-strings": "static-1.8023",
  "redux-observable": "static-1.72",
  "rxjs": "static-5.10",
  "ui-shepherd-react": "static-3.10510",
  "unified-auth": "static-1.800",
  "breeze-engine-chat-components": "static-1.545",
  "breeze-engine-core": "static-1.845",
  "ably": "static-2.2",
  "highlight.js": "static-1.83",
  "navigation-messaging": "static-1.8038",
  "content-media-composition-data-lib": "static-1.13109",
  "content-media-compositions": "static-2.17116",
  "idb-keyval": "static-1.48",
  "media-bridge-lib": "static-1.19335",
  "unified-auth-core-lib": "static-1.1082",
  "social-insights-client-types": "static-1.22685",
  "advanced-menus-core": "static-1.15510",
  "advanced-menus-lib": "static-1.12391",
  "ExportDialog": "static-6.10627",
  "ui-memberships-settings-lib": "static-1.34709",
  "conditional-properties-service-client": "static-1.3976",
  "crm-pipelines-api-client-types": "static-1.4308",
  "fdsr-migration-layer": "static-1.260",
  "framework-builder-read-service-client": "static-1.4181",
  "framework-data-schema-quick-fetch": "static-1.7046",
  "inbound-db-meta-service-client": "static-1.3718",
  "multi-currency-client-types": "static-1.3869",
  "persist-promise": "static-1.3948",
  "foundations-components-test-utils": "static-1.5866",
  "reactive-lib": "static-1.968",
  "react-immutable-render-mixin": "static-1.9",
  "hubspot-apollo-cache": "static-1.583",
  "universal-page-editor-lib": "static-1.3256",
  "adobe-sign-auth-lib": "static-1.350",
  "ads-unified-auth-lib": "static-1.1034",
  "google-sheets-integration-lib": "static-1.926",
  "microsoft-drive-auth-lib": "static-1.17",
  "surveymonkey-integration-lib": "static-1.370",
  "slack-ui-library": "static-1.10643",
  "js-cookie": "static-1.18",
  "fsm": "static-1.3985",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15509",
  "simple-menus-lib": "static-1.17026",
  "crm-record-cards-service-types": "static-1.3756",
  "location-customization-utils-lib": "static-1.9986",
  "react-flip-move": "static-1.75"
},
  depPathPrefixes: {
  "feedback-public-submission-ui": "/feedback-public-submission-ui/static-1.30711",
  "emoji-mart": "/emoji-mart/static-3.4",
  "feedback-schema": "/feedback-schema/static-1.55218",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8274",
  "hubspot-dlb": "/hubspot-dlb/static-2.1882",
  "HubStyleTokens": "/HubStyleTokens/static-2.11730",
  "I18n": "/I18n/static-7.1661",
  "quartz": "/quartz/static-1.7365",
  "quartz-config": "/quartz-config/static-1.1143",
  "quartz-core": "/quartz-core/static-1.6584",
  "react-dlb": "/react-dlb/static-1.84",
  "react-dnd": "/react-dnd/static-4.51",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-2.10",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-thunk": "/redux-thunk/static-2.77",
  "reselect": "/reselect/static-3.9",
  "sinon": "/sinon/static-1.9",
  "tinymce": "/tinymce/static-6.5",
  "cssUtils": "/cssUtils/static-1.870",
  "enviro": "/enviro/static-4.455",
  "feedback-shared-ui": "/feedback-shared-ui/static-1.55205",
  "feedback-utils": "/feedback-utils/static-1.55209",
  "forms-embed-utils-lib": "/forms-embed-utils-lib/static-1.4712",
  "forms-utils-lib": "/forms-utils-lib/static-1.13018",
  "foundations-assets": "/foundations-assets/static-1.5123",
  "foundations-components": "/foundations-components/static-1.8383",
  "foundations-theming": "/foundations-theming/static-1.4702",
  "hub-http": "/hub-http/static-1.6458",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4297",
  "HubStyle": "/HubStyle/static-2.12037",
  "icons": "/icons/static-2.674",
  "immutable": "/immutable/static-2.83",
  "quick-fetch": "/quick-fetch/static-1.4093",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-dom": "/react-dom/static-7.85",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-redux": "/react-redux/static-7.75",
  "react-rhumb": "/react-rhumb/static-1-unify-reporter-duration-calculations.6",
  "react-select-plus": "/react-select-plus/static-1.109",
  "react-utils": "/react-utils/static-2.5516",
  "react-virtualized": "/react-virtualized/static-2.104",
  "redux": "/redux/static-4.76",
  "StyleGuideUI": "/StyleGuideUI/static-3.495",
  "tinymce-plugins": "/tinymce-plugins/static-1.58112",
  "transmute": "/transmute/static-2.85",
  "ui-images": "/ui-images/static-2.1229",
  "UIComponents": "/UIComponents/static-3.8676",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "metrics-js": "/metrics-js/static-1.9867",
  "styled-components": "/styled-components/static-2.95",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3575",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3642",
  "quartz-webpack": "/quartz-webpack/static-1.3589",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2418",
  "property-description-translator": "/property-description-translator/static-1.4085",
  "HeadJS": "/HeadJS/static-2.789",
  "framer-motion": "/framer-motion/static-1.76",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3385",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.156",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.87",
  "jasmine": "/jasmine/static-4.4564",
  "jasmine-runner": "/jasmine-runner/static-1.6696",
  "dispatcher": "/dispatcher/static-1.141",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.867",
  "hubspotter-http": "/hubspotter-http/static-1.4824",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.565",
  "module-federation": "/module-federation/static-1.30",
  "quartz-auth": "/quartz-auth/static-1.1040",
  "quartz-head": "/quartz-head/static-1.1030",
  "quartz-i18n": "/quartz-i18n/static-1.1040",
  "quartz-routing": "/quartz-routing/static-1.795",
  "quartz-test": "/quartz-test/static-1.1040",
  "quartz-tracking": "/quartz-tracking/static-1.744",
  "trellis-components": "/trellis-components/static-1.2487",
  "ui-fonts": "/ui-fonts/static-1.992",
  "usage-tracker-container": "/usage-tracker-container/static-1.7592",
  "usage-tracker-core": "/usage-tracker-core/static-1.7452",
  "hs-lodash": "/hs-lodash/static-4.45",
  "sassPrefix": "/sassPrefix/static-1.161",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7495",
  "reference-resolvers": "/reference-resolvers/static-1.8429",
  "sanitize-text": "/sanitize-text/static-1.8396",
  "PatternValidationJS": "/PatternValidationJS/static-1.3143",
  "ReduxMessenger": "/ReduxMessenger/static-2.10613",
  "sanitize": "/sanitize/static-1.4722",
  "outpost": "/outpost/static-1.4408",
  "rpc-client-utils": "/rpc-client-utils/static-1.4909",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4652",
  "floating-ui": "/floating-ui/static-1.61",
  "hs-story-utils": "/hs-story-utils/static-1.9674",
  "react-aria": "/react-aria/static-1.70",
  "react-create-root-preference": "/react-create-root-preference/static-1.60",
  "tanstack-table": "/tanstack-table/static-1.59",
  "trellis-assets": "/trellis-assets/static-1.2468",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3185",
  "foundations-theming-base": "/foundations-theming-base/static-1.3687",
  "stylex": "/stylex/static-1.38",
  "hs-locale-management": "/hs-locale-management/static-1.255",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.11",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9579",
  "atom": "/atom/static-1.5331",
  "codemirror": "/codemirror/static-5.99",
  "content-assistance-lib": "/content-assistance-lib/static-1.8130",
  "ContentUtils": "/ContentUtils/static-1.69053",
  "data-token-picker": "/data-token-picker/static-1.16813",
  "file-manager-components": "/file-manager-components/static-1.24360",
  "FileManagerCore": "/FileManagerCore/static-1.39859",
  "FileManagerLib": "/FileManagerLib/static-1.40000",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8174",
  "hub-http-contrib": "/hub-http-contrib/static-1.3285",
  "interframe": "/interframe/static-3.5003",
  "layout-dnd-components": "/layout-dnd-components/static-1.12890",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11865",
  "property-translator": "/property-translator/static-1.5641",
  "react-codemirror": "/react-codemirror/static-1.10886",
  "react-colorpicker": "/react-colorpicker/static-2.10454",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8346",
  "rich-text-lib": "/rich-text-lib/static-1.20235",
  "tinymce-data": "/tinymce-data/static-1.41083",
  "tinymce-themes": "/tinymce-themes/static-1.56968",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10132",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5461",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16217",
  "bender-build-tools": "/bender-build-tools/static-1.3358",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10525",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10523",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5288",
  "base-ui": "/base-ui/static-1.19",
  "react-day-picker": "/react-day-picker/static-1.7",
  "trellis-theming": "/trellis-theming/static-1.1207",
  "tanstack-virtual": "/tanstack-virtual/static-1.36",
  "autolinker": "/autolinker/static-3.11",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.319",
  "chirp-fetch": "/chirp-fetch/static-1.2137",
  "chatspot-core": "/chatspot-core/static-1.22631",
  "copilot-toolkit": "/copilot-toolkit/static-1.11740",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13277",
  "data-fetching-client": "/data-fetching-client/static-1.9903",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "superstore": "/superstore/static-1.5005",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8952",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29210",
  "usage-tracker": "/usage-tracker/static-1.7602",
  "cms-field-types": "/cms-field-types/static-1.5061",
  "content-icons-ui": "/content-icons-ui/static-1.2310",
  "integrations-lib": "/integrations-lib/static-1.16923",
  "customer-data-objects": "/customer-data-objects/static-1.7934",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1567",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4903",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.90",
  "graphql": "/graphql/static-1.86",
  "immer": "/immer/static-1.94",
  "immerable": "/immerable/static-1.4398",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9323",
  "video-components-external": "/video-components-external/static-1.12053",
  "video-data-lib": "/video-data-lib/static-1.35711",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.185",
  "audio-components": "/audio-components/static-1.6272",
  "cropperjs": "/cropperjs/static-1.10",
  "feedback-loader": "/feedback-loader/static-1.29734",
  "FileManagerImages": "/FileManagerImages/static-1.37511",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1408",
  "html-to-image": "/html-to-image/static-1.58",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.75",
  "salesImages": "/salesImages/static-1.530",
  "ui-universal-auth": "/ui-universal-auth/static-1.9286",
  "urlinator": "/urlinator/static-1.4780",
  "video-components": "/video-components/static-1.14055",
  "video-embed": "/video-embed/static-1.36545",
  "ts-schema": "/ts-schema/static-1.4254",
  "ContentData": "/ContentData/static-1.69128",
  "layout-data-lib": "/layout-data-lib/static-1.10190",
  "react-dnd-compat": "/react-dnd-compat/static-1.4862",
  "browser-eslint": "/browser-eslint/static-2.57",
  "batch-promise": "/batch-promise/static-1.1791",
  "external-options-client-types": "/external-options-client-types/static-1.4301",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7141",
  "hs-promise-utils": "/hs-promise-utils/static-1.5842",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4018",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9224",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3308",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11393",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "markdown-it": "/markdown-it/static-1.6",
  "magpie-lib": "/magpie-lib/static-1.5718",
  "magpie-types": "/magpie-types/static-1.5178",
  "simple-logging-lib": "/simple-logging-lib/static-1.3296",
  "avatar-components": "/avatar-components/static-1.2743",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10072",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6829",
  "flux-actions": "/flux-actions/static-1.360",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5124",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14338",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5855",
  "laboratory-lib": "/laboratory-lib/static-3.7399",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8023",
  "redux-observable": "/redux-observable/static-1.72",
  "rxjs": "/rxjs/static-5.10",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10510",
  "unified-auth": "/unified-auth/static-1.800",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.545",
  "breeze-engine-core": "/breeze-engine-core/static-1.845",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.83",
  "navigation-messaging": "/navigation-messaging/static-1.8038",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13109",
  "content-media-compositions": "/content-media-compositions/static-2.17116",
  "idb-keyval": "/idb-keyval/static-1.48",
  "media-bridge-lib": "/media-bridge-lib/static-1.19335",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1082",
  "social-insights-client-types": "/social-insights-client-types/static-1.22685",
  "advanced-menus-core": "/advanced-menus-core/static-1.15510",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12391",
  "ExportDialog": "/ExportDialog/static-6.10627",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.34709",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3976",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4308",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.260",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4181",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7046",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3869",
  "persist-promise": "/persist-promise/static-1.3948",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5866",
  "reactive-lib": "/reactive-lib/static-1.968",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.583",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3256",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.350",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1034",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.926",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.17",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.370",
  "slack-ui-library": "/slack-ui-library/static-1.10643",
  "js-cookie": "/js-cookie/static-1.18",
  "fsm": "/fsm/static-1.3985",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15509",
  "simple-menus-lib": "/simple-menus-lib/static-1.17026",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3756",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9986",
  "react-flip-move": "/react-flip-move/static-1.75"
}
};
